import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import r from "../../Color.js";
import { JSONSupport as o } from "../../core/JSONSupport.js";
import { isSome as s } from "../../core/maybe.js";
import { px2pt as e } from "../../core/screenUtils.js";
import { property as p } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import { symbol3dLinePatternProperty as a } from "../patterns/utils.js";
import { colorAndTransparencyProperty as c, screenSizeProperty as l } from "./materialUtils.js";
import { lineCaps as n } from "./symbolLayerUtils3D.js";

var _m;

var u = _m = /*#__PURE__*/function (_o) {
  _inherits(m, _o);

  var _super = _createSuper(m);

  function m(t) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this, t), _this.color = new r([0, 0, 0, 1]), _this.size = e(1), _this.pattern = null, _this.patternCap = "butt";
    return _this;
  }

  _createClass(m, [{
    key: "clone",
    value: function clone() {
      var t = {
        color: s(this.color) ? this.color.clone() : null,
        size: this.size,
        pattern: s(this.pattern) ? this.pattern.clone() : null,
        patternCap: this.patternCap
      };
      return new _m(t);
    }
  }]);

  return m;
}(o);

t([p(c)], u.prototype, "color", void 0), t([p(l)], u.prototype, "size", void 0), t([p(a)], u.prototype, "pattern", void 0), t([p({
  type: n,
  json: {
    default: "butt",
    write: {
      overridePolicy: function overridePolicy() {
        return {
          enabled: s(this.pattern)
        };
      }
    }
  }
})], u.prototype, "patternCap", void 0), u = _m = t([i("esri.symbols.support.Symbol3DOutline")], u);
var j = u;
export { j as default };